<script setup>
import PricesTable from "@/components/organisms/PricesTable.vue";
import FAQ from "@/components/molecules/FAQ.vue";

const props = defineProps({
  data: Object
})

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: props.data.structured_data
    },
  ]
})
</script>

<template>
  <section v-if="Object.values(data.faq).length">
    <PricesTable :category_name="data.product_category.name" :items="Object.values(data.faq)[0]?.li"/>
  </section>
  <section v-if="Object.values(data.faq).length">
    <FAQ :category_name="data.product_category.name" :items="data.faq"/>
  </section>
</template>
